
<template>
    <b-modal ref="profile_modal"
             size="xl"
             bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <!-- BODY -->
        <div id="panel_user_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
					<span class="fw-300">

					</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="panel-container show">
                <b-overlay :show="is_load" rounded="sm">
                    <div class="panel-container show">
                        <div class="panel-content mb-0">
                            <div class="user_auth">
                                <form class="user" autocomplete="off">
                                    <div class="form-group">
                                        <label class="form-label" for="input-live-feedback_username">
                                            {{__t('YANDEX_CLIENT_ID')}}
                                        </label>
                                        <b-form-input
                                            :disabled="true"
                                            id="input-live-feedback_username"
                                            v-model="user_form.client_id"
                                            class="form-control form-control-use"
                                            placeholder="Логин">
                                        </b-form-input>
                                    </div>



                                    <div class="form-group mt-3">
                                        <label class="form-label" for="input-live-feedback_username">
                                            {{__t('YANDEX_CLIENT_SECRET')}}
                                        </label>

                                        <b-form-input
                                            :disabled="true"
                                            id="user_pass_register"
                                            v-model="user_form.client_secret" class="form-control form-control-user"
                                            placeholder="Пароль"></b-form-input>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </b-overlay>
            </div>
            <!--FOOTER -->
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">

            </div>
        </template>
    </b-modal>
</template>

<script>
import Yes_no from "../../../../sys/radio/yes_no.vue";

export default {
    name: "yandex_auth_info",
    components: {Yes_no},
    props : {
        modal_position : {
            type : String,
            default : "left"
        },
    },
    data() {
        return  {
            is_show_modal : false,
            is_load : false,
            user_form : {
                client_id       : "",
                client_secret   : "",
            },
        }
    },
    created() {
        EventBus.$on("yandex_auth_info",this.work_click);
    },
    methods : {

        close_modal() {
            this.close()
        },
        close() {
            this.is_show_modal = false;
        },

        work_click() {
            this.load_current_settings();
            this.is_show_modal = true;
        },

        async load_current_settings()
        {
            agr_api.get('/aggregators/yandex/auth/info').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.user_form = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
            });
        },
    },

    computed : {
        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-sm";
            }

            return "modal-dialog-right modal-sm";
        },
    }

}
</script>


<style scoped>

</style>
